var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50781 14.874L15.1972 20.5634L13.0943 22.6663C12.7208 23.0404 12.2773 23.3371 11.7891 23.5397C11.3008 23.7422 10.7775 23.8466 10.2489 23.8468C9.72039 23.847 9.19697 23.743 8.7086 23.5408C8.22024 23.3386 7.7765 23.0422 7.40276 22.6685V22.6685C7.02901 22.2947 6.73257 21.851 6.53039 21.3626C6.32821 20.8743 6.22425 20.3508 6.22445 19.8223C6.22464 19.2937 6.329 18.7704 6.53154 18.2822C6.73408 17.7939 7.03085 17.3504 7.40488 16.977L9.50781 14.874Z",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26.1441L7.493 22.6511",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4883 15.27L14.7989 9.58064L16.9018 7.4777C17.2753 7.10368 17.7188 6.80691 18.207 6.60436C18.6952 6.40182 19.2186 6.29747 19.7471 6.29727C20.2757 6.29707 20.7991 6.40104 21.2875 6.60322C21.7759 6.8054 22.2196 7.10183 22.5933 7.47558V7.47558C22.9671 7.84933 23.2635 8.29307 23.4657 8.78143C23.6679 9.26979 23.7718 9.79321 23.7716 10.3218C23.7715 10.8503 23.6671 11.3737 23.4646 11.8619C23.262 12.3501 22.9652 12.7936 22.5912 13.1671L20.4883 15.27Z",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0008 4L22.5078 7.493",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9266 12.2991L12.2266 14.9991",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7703 15.144L15.0703 17.844",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.2ef860163990deb0b30629cdccbc9c90.svg";
export { ForwardRef as ReactComponent };